{
  "title": "Welcome to Boomerang",
  "search": "Search",
  "actions": {
    "recondition": "Recondition",
    "recycle": "Recycle",
    "newRepairFile": "New Repair / Service request file"
  },
  "currentRepairFiles": {
    "title": "Current repair files",
    "subtitle": "Track your current repair files",
    "seeMore": "See more",
    "table": {
      "reference": "File",
      "company": "Company name",
      "manufacturer": "Brand",
      "product": "Product name",
      "status": "Status",
      "time": "Time",
      "modality": "Support"
    }
  },
  "kpi": {
    "title": "Product park",
    "teamUsage": "tools currently in use",
    "seeMore": "See more"
  },
  "footer": {
    "averageCustomer": ">85%",
    "averageResponse": " automatic estimates",
    "guarantee": "Up to 6 months Boomerang warranty",
    "productLabel": "products",
    "manufacturerLabel": "brands",
    "button": "Train on Boomerang with our teams"
  }
}
